import { render, staticRenderFns } from "./ProductPageBanner.vue?vue&type=template&id=ca0c47e6&scoped=true&"
import script from "./ProductPageBanner.vue?vue&type=script&lang=js&"
export * from "./ProductPageBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageBanner.vue?vue&type=style&index=0&id=ca0c47e6&prod&scoped=true&lang=css&"
import style1 from "./ProductPageBanner.vue?vue&type=style&index=1&id=ca0c47e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0c47e6",
  null
  
)

export default component.exports